import React,  { Fragment, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Routes from "./Containers/Routes";
import ReassignPharmacyConfirmation from "./Containers/modal/reassignPharmacy";
import ReassignPharmacyUploadConfirm from "./Containers/modal/reassignPharmacyUpload";
import CommonSuccessMsg from "./Containers/successMsg";
import CommonErrorMsg from "./Containers/errorMsg";
import SuspendBatchConfirmation from "./Containers/AdminConsole/modal/suspendBatch";
import StatusUpdateModal from "./Containers/AdminConsole/modal/statusUpdate";
import StatusUpdateConfirmModal from "./Containers/AdminConsole/modal/statusUpdateConfirmation";
import UpdatePharmacyStatus from "./Containers/AdminConsole/modal/updatePharmacyStatus";
import AddHealthDistrictAdminModal from "./Containers/AdminConsole/modal/addHealthDistrictAdmin";
import DeleteConfirmationModal from "./Containers/AdminConsole/modal/deleteConfirmationModal";
import EditQuotaModal from "./Containers/common/modal/editQuota";
import DeactivateOrActivatePublicAdminModal from "./Containers/AdminConsole/modal/deactivateOrActivatePublicAdmin";
import useInspectorAuthTasksCounts from "./Hooks/useInspectorAuthTasksCounts";
import ProductMappingsFailureModal from "./Containers/AdminConsole/modal/productMappingsFailure";
import EditDistributorProductCode from "./Containers/AdminConsole/modal/editDistributorProductCode";
import { logOut } from "./modules/AdminConsole/auth";

const AppWrapper = (props) => {
    const warningTimeout = 20 * 60000; // Display warning in 20 minutes.
    const logoutTimeout = 6000; // Warning has been shown, give the user 1 minute to interact.
    let warningTimerID;
    let logoutTimerID;

    const formatMessage = (data) => props.intl.formatMessage(data);

    function logoutUser() {
        // console.log('User has been logged out.');
        if(props.adminAuthenticated || props.authenticated || props.inspectorAuthenticated)
        {
        alert(formatMessage({
            id: "app.appwrapper.sessionExpired",
            description: "Session Expired, you're logged out.",
            defaultMessage: "Session Expired, you're logged out."
          }));
        props.logOut();
        }
        
        // window.location.href = logoutUrl;
    }
    
    function showIdleWarning() {
        clearTimeout(warningTimerID);
        logoutTimerID = setTimeout(logoutUser, logoutTimeout);
        // Display a warning message to the user (you can customize this part).
        // Example: alert(\"Warning: Your session will be logged out due to inactivity.\");
        // console.log('Idle warning shown.');
    }

    function startWarningTimer() {
        warningTimerID = setTimeout(showIdleWarning, warningTimeout);
        console.log('Warning timer started.');
    }

    function resetLogoutTimer() {
        // console.log('resettttt', logoutTimerID)
        clearTimeout(logoutTimerID);
        // startWarningTimer();
        // Close any existing warning dialog (you can customize this part).
        // Example: $(\"#timeout\").dialog('close');
    }

	const handleVisibilityChange = () => {
        if (document.hidden) {
            // console.log("The page is not visible.");
            // Your code for when the page is visible
            // Set timeout variables.
            // Start the initial warning timer.
            startWarningTimer();
        } else {
            // console.log("The page is visible.", document.cookie);
            // Reset the logout timer.
            resetLogoutTimer();
        }
    };
    const inactivityTime = () => {
        let time;
        window.onload = resetTimer;
        // Events
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;
     
        function resetTimer() {
          clearTimeout(time);
          time = setTimeout(logoutUser, 20 * 60000);  // Set the time in milliseconds
        }
      };
     
      inactivityTime();
     
    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

	useInspectorAuthTasksCounts()
	return (
	<Router>
	<Fragment>
	<Routes />
	<Fragment>
	<CommonSuccessMsg />
	<CommonErrorMsg />
	<ReassignPharmacyConfirmation />
	<SuspendBatchConfirmation />
	<StatusUpdateModal />
	<StatusUpdateConfirmModal />
	<UpdatePharmacyStatus />
	<AddHealthDistrictAdminModal />
	<DeleteConfirmationModal />
	<EditQuotaModal />
	<ReassignPharmacyUploadConfirm />
	<DeactivateOrActivatePublicAdminModal />
	<ProductMappingsFailureModal />
	<EditDistributorProductCode />
	</Fragment>
	</Fragment>
	
    </Router>
	)
};

const mapStateToProps = state => {
    const {AdminAuth: {authenticated: adminAuthenticated = false}, auth: { authenticated = false}, InspectorAuth: {authenticated: inspectorAuthenticated = false }} = state;
    // console.log('aloostateee', state)
    return {adminAuthenticated, authenticated, inspectorAuthenticated};
};

const mapDispatchToProps = dispatch => {
    return {
        logOut: () => dispatch(logOut())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AppWrapper));

// export default injectIntl(AppWrapper);
